import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-35a18d26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "team-info-wrap" }
const _hoisted_2 = { class: "main-head" }
const _hoisted_3 = { class: "main-scroller" }
const _hoisted_4 = { class: "part-wrap" }
const _hoisted_5 = { class: "part-head" }
const _hoisted_6 = { class: "part-header" }
const _hoisted_7 = { class: "part-unit" }
const _hoisted_8 = { class: "part-content" }
const _hoisted_9 = { class: "info-label" }
const _hoisted_10 = { class: "info-value" }
const _hoisted_11 = { class: "part-wrap" }
const _hoisted_12 = { class: "part-head" }
const _hoisted_13 = { class: "part-header" }
const _hoisted_14 = { class: "part-unit" }
const _hoisted_15 = { class: "part-content" }
const _hoisted_16 = { class: "info-label" }
const _hoisted_17 = { class: "info-value" }
const _hoisted_18 = { class: "info-diff" }
const _hoisted_19 = { style: {"margin-right":"2px"} }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 1,
  style: {"color":"#31C872"}
}
const _hoisted_22 = {
  key: 2,
  style: {"color":"#E54545"}
}

import { computed, PropType, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { TeamItem } from '@/views/dashboard/cascade-center/branch-overview/branch-overview.service'
import EllipsisText from '@/views/dashboard/_components/ellipsis-text/ellipsis-text.vue'
import TerminalCount from '@/views/dashboard/cascade-center/branch-overview/_components/terminal-count/terminal-count.vue'
import EmptyData from '@/views/dashboard/_components/empty-data/empty-data.vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import {
  RiskInfo,
  TeamInfoService, TeamTerminalInfo
} from '@/views/dashboard/cascade-center/branch-overview/_components/team-info/team-info.service'
import Axios from 'axios'
import { team, user } from '@/common/basis/root-injector'
import { CascadeLoginService } from '@/services/cascade-login.service'
import { PermissionsState } from '@/views/dashboard/cascade-center/approval/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'team-info',
  props: {
  baseInfo: {
    type: {} as PropType<TeamItem>,
    default: () => ({})
  },
  treeData: {
    type: {} as PropType<TeamItem>,
    default: () => ({})
  },
  isFormLoading: {
    type: Boolean,
    default: false,
  }
},
  setup(__props) {

const { t, locale } = useI18n()

const props = __props

const injector = useReflectiveInjector([TeamInfoService, CascadeLoginService])
const service = injector.get(TeamInfoService)
const cascadeLoginService = injector.get(CascadeLoginService)

const isLoading = ref(false)
const teamInfo = ref({} as TeamTerminalInfo)
const updateDataCancel = ref(null)

const terminalInfo = computed(() => {
  void locale.value
  return [
    {
      label: t('cascadeBranchOverview.teamInfoStatTotal'),
      value: teamInfo.value.total
    },
    {
      label: t('cascadeBranchOverview.teamInfoStatOnline'),
      value: teamInfo.value.online_num
    },
    {
      label: t('cascadeBranchOverview.teamInfoStatOffline'),
      value: teamInfo.value.offline_num
    },
  ]
})

const riskInfo = computed(() => {
  void locale.value
  const { risk_info = {} as RiskInfo } = teamInfo.value
  return [
    {
      label: t('cascadeBranchOverview.riskVirusTerminals'),
      value: risk_info.virus_affect_count,
      diff: getDiff(risk_info.virus_affect_count, risk_info.last_virus_affect_count),
    },
    {
      label: t('cascadeBranchOverview.riskPortTerminals'),
      value: risk_info.port_affect_count,
      diff: getDiff(risk_info.port_affect_count, risk_info.last_port_affect_count),
    },
    {
      label: t('cascadeBranchOverview.riskBaselineTerminals'),
      value: risk_info.baseline_substandard_count,
      diff: getDiff(risk_info.baseline_substandard_count, risk_info.last_baseline_substandard_count),
    },
    {
      label: t('cascadeBranchOverview.riskLeakTerminals'),
      value: risk_info.leak_affect_count,
      diff: getDiff(risk_info.leak_affect_count, risk_info.last_virus_affect_count),
    },
    {
      label: t('cascadeBranchOverview.riskRansomwareTerminals'),
      value: risk_info.ransomware_affect_count,
      diff: getDiff(risk_info.ransomware_affect_count, risk_info.last_ransomware_affect_count),
    },
  ]
})

const cascadeLoginError = computed(() => {
  void locale.value
  if (!teamInfo.value?.permissions?.includes(PermissionsState.Password_free_login)) {
    return t('cascadeBranchOverview.loginNoPermission')
  }
  if (+props.baseInfo.online === 2) {
    return t('cascadeBranchOverview.childTeamDisconnected')
  }
  return ''
})

function updateData () {
  if (props.baseInfo?.team_id === undefined) return

  updateDataCancel.value?.()
  isLoading.value = true
  service.getTeamInfo({ team_id: props.baseInfo?.team_id }, {
    cancelToken: new Axios.CancelToken((callback) => updateDataCancel.value = callback)
  }).then((res) => {
    // 本地调试级联登录用
    // res.team_terminal_info.server_port = 80
    // res.team_terminal_info.ip_addr = 'http://192.168.31.254'

    teamInfo.value = res.team_terminal_info
    isLoading.value = false
  }).catch((error) => {
    if (!error.__CANCEL__) {
      isLoading.value = false
    }
  })
}

function getDiff (newValue: number = 0, oldValue: number = 0) {
  return newValue - oldValue
}

function loginChildTeam () {
  cascadeLoginService.cascadeLogin({
    ip_addr: teamInfo.value.ip_addr,
    server_port: teamInfo.value.server_port,
    access_code: teamInfo.value.access_code,
    child_team_name: teamInfo.value.name,
    child_team_id: teamInfo.value.team_id,
    parent_team_id: team.getCurrentTeam()?.team_id,
    parent_token: user.getUserInfo()?.token,
  })
}

watch(() => props.baseInfo?.team_id, () => {
  updateData()
}, { immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.baseInfo.team_id !== undefined)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(EllipsisText, {
              class: "main-header",
              content: __props.baseInfo.name
            }, null, 8, ["content"]),
            (+_unref(team).getCurrentTeam()?.team_id !== +__props.baseInfo.team_id)
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 0,
                  effect: "light",
                  placement: "top",
                  content: cascadeLoginError.value,
                  disabled: !cascadeLoginError.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "primary",
                      onClick: loginChildTeam,
                      disabled: !!cascadeLoginError.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('cascadeBranchOverview.loginControlCenter')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }, 8, ["content", "disabled"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('cascadeBranchOverview.teamInfoSectionTerminal')), 1),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('cascadeBranchOverview.teamInfoUnitLabel')), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(terminalInfo.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "terminal-info-card el-card",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(item.label), 1),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(item.value || 0), 1)
                  ]))
                }), 128)),
                _createVNode(TerminalCount, {
                  class: "terminal-info-card el-card",
                  style: {"width":"calc(100% - 8px)"},
                  "team-info": teamInfo.value
                }, null, 8, ["team-info"])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)('cascadeBranchOverview.teamInfoSectionRisk')), 1),
                _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(t)('cascadeBranchOverview.teamInfoUnitLabel')), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(riskInfo.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "risk-info-card el-card",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_16, _toDisplayString(item.label), 1),
                    _createElementVNode("div", _hoisted_17, _toDisplayString(item.value || 0), 1),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(t)('cascadeBranchOverview.riskDiffVsLastWeek')), 1),
                      (!item.diff)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, "--"))
                        : (item.diff < 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(item.diff), 1))
                          : (item.diff > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_22, "+" + _toDisplayString(item.diff), 1))
                            : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ], 64))
      : (!(__props.isFormLoading || isLoading.value))
        ? (_openBlock(), _createBlock(EmptyData, {
            key: 1,
            height: "100%"
          }))
        : _createCommentVNode("", true)
  ])), [
    [_directive_loading, __props.isFormLoading || isLoading.value]
  ])
}
}

})